export default __webpack_public_path__ + "static/media/R30.20c808bf.png";